import { useFeatureFlagCookieContext } from '@usap/core'

const useGetHassleFreeFlag = () => {
  const cookieObject = useFeatureFlagCookieContext()
  const {
    hassleFreeReturn,
    lifetimeReplacement,
  } = { ...cookieObject }

  return {
    isLifetimeReplacement: lifetimeReplacement,
    isHassleFree: hassleFreeReturn,
  }
}

export default useGetHassleFreeFlag
